<div
  (click)="onClick($event)"
  (keydown.enter)="onEnter($event)"
  class="overlay"
>
  <ng-container *ngIf="!isLoading">
    <div class="overlay__header"></div>
    <div class="overlay__aside"></div>
    <div class="overlay__content"></div>
  </ng-container>
  <div
    *ngIf="isLoading"
    class="overlay__loading"
  >
    <div *ngIf="loadingType === overlayService.loadingType.GIF">
      <img
        [src]="loadingGifSrc"
        class="overlay__loading-gif"
      />
    </div>
    <qima-spinner
      *ngIf="loadingType === overlayService.loadingType.SPINNER"
      [qimaSpinnerSize]="150"
      [qimaSpinnerUnit]="spinnerService.unit.PIXEL"
      [style.color]="qimaColor.pool.POOL_500"
    ></qima-spinner>
    <qima-three-squares-loader
      *ngIf="loadingType === overlayService.loadingType.THREE_SQUARES"
      [qimaThreeSquaresLoaderSize]="120"
      [qimaThreeSquaresLoaderStyle]="threeSquaresLoaderService.style.POOL_500"
      [qimaThreeSquaresLoaderUnit]="threeSquaresLoaderService.unit.PIXEL"
    ></qima-three-squares-loader>
  </div>
</div>
